<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <avg-messages-per-session
          v-if="avgData && avgData.avg_no_messages_per_sessions"
          :channels="avgData.avg_no_messages_per_sessions"
        />
      </div>
      <div class="col-md-6">
        <messages-per-channel
          v-if="avgData && avgData.no_messages_per_channel"
          :channels="avgData.no_messages_per_channel"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-sm-12">
        <avg-total-messages-per-session
          v-if="avgData && avgData.avg_total_messages_per_session"
          :total-data="avgData.avg_total_messages_per_session"
        />
      </div>
      <div class="col-md-6 col-sm-12">
        <total-messages-per-channel
          v-if="avgData && avgData.messages_per_channel"
          :total-data="avgData.messages_per_channel"
        />
      </div>
      <!-- <div class="col-md-6">
        <total-messages-type
          v-if="avgData && avgData.total_messages_per_bot_user"
          :total-data="avgData.total_messages_per_bot_user"
        />
      </div> -->
    </div>
  </div>
</template>

<script>
import avgMessagesPerSession from './avgMessagesPerSession'
import avgTotalMessagesPerSession from './avgTotalMessagesPerSession'
import messagesPerChannel from './messagesPerChannel'
// import totalMessagesType from './totalMessagesType'
// import totalSessions from './totalSessions'
import totalMessagesPerChannel from './totalMessagesPerChannel'
import insights from '@/utils/analytics/insights'
export default {
  name: 'AvgChartsIndex',
  components: {
    totalMessagesPerChannel,
    avgMessagesPerSession,
    avgTotalMessagesPerSession,
    messagesPerChannel
    // totalMessagesType,
    // totalSessions,
  },
  props: {
    from: {
      type: String,
      default: null
    },
    to: {
      type: String,
      default: null
    },
    accountData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      avgData: {},
      loading: false
    }
  },
  mounted() {
    this.getData()
  },
  watch: {
    from() {
      this.getData()
    },
    to() {
      this.getData()
    }
  },
  methods: {
    getData() {
      this.loading = true
      let data = insights.getAccountAverageData(this.$route.params.id, {
        params: {
          from: this.from,
          to: this.to
        }
      })
      data
        .then((data) => {
          this.avgData = data
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style src="@/assets/css/bs-helpers.css" lang="css" scoped/>
